import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container } from "reactstrap";
import { Button } from "./Button";
import { ReactComponent as ChevronRight } from "./chevronRight.svg";
import "./PriceReport.scss";
import Table from "./Table";

const PriceReport = props => <div className="PriceReport" {...props} />;

const Header = ({ children }) => (
  <div className="header">
    <div className="header__container">{children}</div>
  </div>
);

// eslint-disable-next-line jsx-a11y/heading-has-content
const HeaderTitle = props => <h2 className="header__title" {...props} />;

const HeaderToolbar = ({ children }) => (
  <Col xs="12">
    <Container className="time-period" fluid>
      {children}
    </Container>
  </Col>
);

const TableSection = ({ children }) => (
  <div className="section">
    <div className="section__container">{children}</div>
  </div>
);

const formatDateToNumbers = (date, t = "D.MM") => format(date, t);

const PreviousWeekButton = ({ onClick, weekStart, weekEnd }) => (
  <Button buttonsize="def" buttoncolor="yellow" onClick={onClick}>
    <ChevronRight className="chevron-icon" />{" "}
    {formatDateToNumbers(weekStart, "DD")}-
    {formatDateToNumbers(weekEnd, "DD.MM.YYYY")}
  </Button>
);

const NextWeekButton = ({ onClick, weekStart, weekEnd }) => (
  <Button buttonsize="def" buttoncolor="yellow" onClick={onClick}>
    {formatDateToNumbers(weekStart, "DD")}-
    {formatDateToNumbers(weekEnd, "DD.MM.YYYY")}{" "}
    <ChevronRight className="chevron-icon chevron-icon--reversed" />
  </Button>
);

const PeriodText = ({ weekStart, weekEnd }) => {
  const { t } = useTranslation(["averagePrices"]);
  return (
    <p className="time-period__text">
      {formatDateToNumbers(weekStart, "DD.MM")}-
      {formatDateToNumbers(weekEnd, "DD.MM.YYYY")}
    </p>
  );
};

const Source = props => <p className="chart__data-source" {...props} />;

const Warning = props => <p className="chart__data-warning" {...props} />;

PriceReport.Header = Header;
PriceReport.HeaderTitle = HeaderTitle;
PriceReport.HeaderToolbar = HeaderToolbar;
PriceReport.TableSection = TableSection;
PriceReport.Table = Table;
PriceReport.PreviousWeekButton = PreviousWeekButton;
PriceReport.NextWeekButton = NextWeekButton;
PriceReport.PeriodText = PeriodText;
PriceReport.Source = Source;
PriceReport.Warning = Warning;

export default PriceReport;
